export function ClipboardTickIcon({ size = 20, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="m7.758 12.25 1.25 1.25 3.334-3.334"
        stroke="#00C48C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.333 5h3.333c1.667 0 1.667-.834 1.667-1.667 0-1.667-.833-1.667-1.667-1.667H8.333c-.833 0-1.666 0-1.666 1.667 0 1.666.833 1.666 1.666 1.666"
        stroke="#00C48C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.333 3.35c2.775.15 4.167 1.175 4.167 4.983v5c0 3.333-.833 5-5 5h-5c-4.167 0-5-1.667-5-5v-5c0-3.8 1.392-4.833 4.167-4.983"
        stroke="#00C48C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
